import React from "react";

export default function About() {
 return (
  <section id="about" className="about">
   <h2 className="about-title">About Us</h2>
   <div className="about-text">
    <h3>Our Mission</h3>
    <p>We are a team of experts in HR management and recruitment.</p>
   </div>
   <div className="about-text">
    <h3>Our Vision</h3>
    <p>We are a team of experts in HR management and recruitment.</p>
   </div>
  </section>
 );
}